import Accordion from 'components/Accordion';
import Link from 'components/Link';
import SectionHeader from 'components/SectionHeader';
import {FC} from 'react';
import {c} from 'ttag';

const MagicLinkFaq: FC = () => {
    const br = <br key="break-line" />;

    const section1 = (() => (
        <Accordion
            className="py-2"
            header={c('portal-faq').t`What is "Business Portals by MakeLeaps"?`}
            isOpenByDefault={true}
        >
            {c('portal-faq')
                .t`"Business Portals by MakeLeaps" is the place where you can interact with your business partners that are MakeLeaps users, starting with access to the history of invoices or other documents and files sent to you.`}
        </Accordion>
    ))();
    const section2 = (() => {
        const link = (
            <Link
                href="https://help.makeleaps.jp/ja/articles/8687205"
                isOpenInNewTab={true}
                key="section-2-business-portals-manual"
                rel="noreferrer"
            >
                {c('portal-faq').t`Business Portals Manual`}
            </Link>
        );
        const boldText = (
            // Japanese translation of this text is expected to be undefined
            <b key="please-contact-your-business-partner">{c('portal-faq')
                .t`please contact your business partner`}</b>
        );
        return (
            <Accordion
                className="py-2"
                header={c('portal-faq')
                    .t`What should I do if I have questions or am seeing an error?`}
            >
                {c('portal-faq')
                    .jt`Please check our ${link} first, which has a special section for troubleshooting.${br}If you're still having issues, ${boldText} who is a MakeLeaps user. (MakeLeaps support is only available to contracted users, so we will not be able to assist you directly. Thank you for your understanding.)`}
            </Accordion>
        );
    })();
    const section3 = (() => {
        const link = (
            <Link
                href="https://www.makeleaps.jp/"
                isOpenInNewTab={true}
                key="web-page"
                rel="noreferrer"
            >
                {c('portal-faq').t`web page (Japanese)`}
            </Link>
        );
        return (
            <Accordion
                className="py-2"
                header={c('portal-faq').t`What is MakeLeaps?`}
            >
                {c('portal-faq')
                    .jt`MakeLeaps is a cloud-based invoice management service, allowing its users to create and send business documents to their Clients.${br}${br}For more details, see our ${link}.`}
            </Accordion>
        );
    })();
    const section4 = (() => {
        const link = (
            <Link
                href="https://help.makeleaps.jp/ja/articles/8687205"
                isOpenInNewTab={true}
                key="section-4-business-portals-manual"
                rel="noreferrer"
            >
                {c('portal-faq').t`Business Portals Manual`}
            </Link>
        );
        return (
            <Accordion
                className="py-2"
                header={c('portal-faq').t`How are Business Portals secured?`}
            >
                {c('portal-faq')
                    .jt`Only email addresses that are configured by MakeLeaps users as Portal Users can log in, and we authorize those Portal Users by sending a unique login link only to the registered email address.${br}${br}More details about security can be found in the ${link}.`}
            </Accordion>
        );
    })();

    return (
        <div className="mt-2 rounded-lg border border-grey-300 bg-white px-6 pb-16 pt-6 shadow-lg">
            <SectionHeader
                classNameTitle="my-2"
                hideHR={true}
                level={2}
                title={c('portal-faq').t`FAQ`}
            />
            {section1}
            {section2}
            {section3}
            {section4}
        </div>
    );
};

export default MagicLinkFaq;
